import { FailureResponse } from '@common/model';
import { PayloadAction } from '@reduxjs/toolkit';
import { DriversState } from '@features/admin/drivers/store/model';

export const updateDriverContractInit = (state: DriversState) => {};
export const updateDriverContractSuccess = (state: DriversState) => {};
export const updateDriverContractFailure = (
  state: DriversState,
  action: PayloadAction<FailureResponse>,
) => {};
